var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v(" Total: "),_c('strong',[_vm._v(_vm._s(_vm.total))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }